/*******************************************************************************
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  *  Copyright © 2020 Pearson Education, Inc.
 *  *  All Rights Reserved.
 *  *
 *  * NOTICE:  All information contained herein is, and remains
 *  * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 *  * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 *  * patent applications, and are protected by trade secret or copyright law.
 *  * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 ******************************************************************************/


import { ACTION_TYPES } from '../actions/ActionTypes';
import EXP_CONSTS from '../common/constants'

export const initialState = {
    isDataLoaded: false,
    studentList: [],
    impersonateActive:''
   }
const UserImperson = (state = initialState, { type, payload }) => {
    switch (type) {

        case ACTION_TYPES.FETCH_STUDENTS:
            return { ...state, studentList: payload,isDataLoaded:true}
        case ACTION_TYPES.IMPERSONATE_ACTIVATE:
            return {
                ...state, impesonateStatus: payload, impersonateActive: true, isDataLoaded: true }
        case ACTION_TYPES.IMPERSONATE_DEACTIVATE:
            return {
                ...state, impesonateStatus: payload, impersonateActive: false, isDataLoaded: true }
        default:
            return { ...state }
    }
}

export default UserImperson;